import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Link, useLocation, matchPath } from 'react-router-dom';
import { Sidenav, Nav } from 'rsuite';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getSideBarData } from '../SidebarData';
import { Theme } from '../../res';


const SideBarNav = (props) => {
    const { user, openCloseSideBar, opened, broken } = props;
    const { t } = useTranslation();
    const { pathname } = useLocation();

    return (
        <Sidenav expanded={opened} style={{ width: 'auto', minHeight: '100vh', backgroundColor: Theme.colors.PRIMARY_50, color: Theme.colors.WHITE }}>
            <Sidenav.Body style={{ backgroundColor: Theme.colors.PRIMARY_50 }}>
                <Nav style={{ backgroundColor: Theme.colors.PRIMARY_50, color: Theme.colors.WHITE }} >
                    {getSideBarData(user.isAdmin).map(item => <Nav.Menu
                        key={item.name}
                        icon={item.icon}
                        // as={!item.subs ? Link : ''}
                        // to={!item.subs ? item.link : ''}
                        eventKey={item.name}
                        title={item.name}
                        active={matchPath(pathname, { path: item.link, exact: true })?.isExact}
                    >
                        {item.subs.map(sub =>
                            <Nav.Item
                                style={{ color: Theme.colors.WHITE, backgroundColor: Theme.colors.PRIMARY_50 }}
                                key={sub.name}
                                icon={<Icon name={sub.icon} />}
                                // title={sub.name}
                                as={Link}
                                to={sub.link}
                                eventKey={sub.name}
                                onClick={broken ? () => openCloseSideBar(false) : undefined}
                                active={matchPath(pathname, { path: sub.link, exact: true })?.isExact}
                            >
                                {sub.name}
                            </Nav.Item>
                        )}
                    </Nav.Menu>
                    )}
                </Nav>
            </Sidenav.Body>
        </Sidenav >
    );
};

const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps)(SideBarNav);
